import script from "./IncomeDetailTable.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomeDetailTable.vue?vue&type=script&setup=true&lang=js"

import "./IncomeDetailTable.vue?vue&type=style&index=0&id=27b0d796&lang=less&scoped=true"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b0d796"]])

export default __exports__